import { render } from "./printingresso.vue?vue&type=template&id=647d31ee&scoped=true"
import script from "./printingresso.vue?vue&type=script&lang=js"
export * from "./printingresso.vue?vue&type=script&lang=js"

import "./printingresso.vue?vue&type=style&index=0&id=647d31ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-647d31ee"]])

export default __exports__